module.exports = __webpack_public_path__ + "img/phone-offerwall.354c734.png";